import type { Ref } from 'vue'

type GlobalI18n = {
  locale: Ref<string>
  t: (key: string) => string
}

// `useI18n()` resolves through the current component instance, so it throws
// ("Must be called at the top of a `setup` function") whenever it is reached
// from a computed that re-evaluates outside a setup/render call stack -- which
// is exactly what a locale switch triggers. The global i18n instance is
// reachable anywhere and its `locale` is the same ref, so it stays reactive.
// See also `useCurrentLocale` in `use-rooms.ts`, which does this for plugins.
export const useGlobalI18n = () => useNuxtApp().$i18n as unknown as GlobalI18n
